module.exports = __webpack_public_path__ + "media/assets/images/blog/glossario-small-7ef4a4d08403a59cd5d471d39b38cf45.png";